import API_CONNECT from './ApiConfig';
import { HANDLE_AXIOS_ERROR } from '../_ApiUtil/handleAxiosError';

export const API_SERVICES = {

    // ----------------------------------------- 🔥 GET AUTH USER AUTHENTICATED (ME)
    GET_AUTHENTICATED_ME_USER: async (resource, token) => {
        try {
            const RESPONSE = await API_CONNECT.get(`${resource}`, {
                headers: { Authorization: `Bearer ${token}` }
            });
            return RESPONSE.data;
        } catch (ERROR) {
            return HANDLE_AXIOS_ERROR(ERROR);
        }
    },

    // ----------------------------------------- 🔥 POST RESOURCE
    POST_RESOURCE: async (resource, data, config = {}) => {
        try {
            const RESPONSE = await API_CONNECT.post(`${resource}`, data, config);
            return RESPONSE.data;
        } catch (ERROR) {
            return HANDLE_AXIOS_ERROR(ERROR);
        }
    },

    // ----------------------------------------- 🔥 PUT RESOURCE
    UPDATE_resource: async (resource, id, data, config = {}) => {
        try {
            const RESPONSE = await API_CONNECT.put(`${resource}${id ? "/" + id : ""}`, data, config);
            return RESPONSE.data;
        } catch (ERROR) {
            return HANDLE_AXIOS_ERROR(ERROR);
        }
    },

    // ----------------------------------------- 🔥 PATCH REOSURCE (con id o sin id)
    /*  Soporta dos firmas para no romper llamadas existentes:
              - PATCH_resource(resource, id, data, config)  -> /resource/:id   (useApiActionMutation)
              - PATCH_resource(resource, data, config)      -> /resource       (llamadas legacy)
            Si el 2do argumento es string o number, se toma como id.  */
    PATCH_resource: async (resource, ...args) => {
        try {
            const HAS_ID = typeof args[0] === "string" || typeof args[0] === "number";

            const ID = HAS_ID ? args[0] : null;
            const DATA = HAS_ID ? args[1] : args[0];
            const CONFIG = (HAS_ID ? args[2] : args[1]) ?? {};

            const URL_RESOURCE = `${resource}${ID != null && ID !== "" ? `/${ID}` : ""}`;

            const RESPONSE = await API_CONNECT.patch(URL_RESOURCE, DATA ?? null, CONFIG);
            return RESPONSE.data;
        } catch (ERROR) {
            return HANDLE_AXIOS_ERROR(ERROR);
        }
    },

    // ----------------------------------------- 🔥 DELETE RESOURCE
    DELETE_resource: async (resource, id, data = null, config = {}) => {
        try {

            const finalConfig = data ? { ...config, data } : config;

            const RESPONSE = await API_CONNECT.delete(`${resource}/${id}`, finalConfig);
            return RESPONSE.data;
        } catch (ERROR) {
            return HANDLE_AXIOS_ERROR(ERROR);
        }
    },

    // ----------------------------------------- 🔥 GET ALL RESOURCES 
    GET_RESOURCES: async (resource, params = {}, config = {}) => {
        try {
            const RESPONSE = await API_CONNECT.get(`${resource}`, {
                params, ...config
            });
            return RESPONSE.data;
        } catch (ERROR) {
            return HANDLE_AXIOS_ERROR(ERROR);
        }
    },

    // ----------------------------------------- 🔥 GET RESOURCE BY ID
    GET_RESOURCE: async (resource, config = {}) => {
        try {
            const RESPONSE = await API_CONNECT.get(`${resource}`, config);
            return RESPONSE.data;
        } catch (ERROR) {
            return HANDLE_AXIOS_ERROR(ERROR);
        }
    },

};